var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23C19.9183 23 23.5 19.4183 23.5 15C23.5 10.5817 19.9183 7 15.5 7C11.0817 7 7.5 10.5817 7.5 15C7.5 19.4183 11.0817 23 15.5 23Z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20C18.2614 20 20.5 17.7614 20.5 15C20.5 12.2386 18.2614 10 15.5 10C12.7386 10 10.5 12.2386 10.5 15C10.5 17.7614 12.7386 20 15.5 20Z",
    fill: "#242424"
  })));
}

export default SvgCircleField;